module.exports = __webpack_public_path__ + "img/vardanian_500.67320b50.jpg";